import React from "react"

import {
    COMMON_METABASE_CONFIG,
    DashboardEmbedType,
} from "@common-shared/config/metabase.config.ts"
import { OneVerifyPermission } from "@common-shared/config/rolesPermissions.config.ts"

import { PageHelmetElement } from "@front-shared/elements/pageHelmet.element.tsx"
import { SpinnerElement } from "@front-shared/elements/spinner.element.tsx"
import { useScrollFix } from "@front-shared/hooks/scrollFix.hook"

import { GENERAL_CONFIG } from "../../config/general.config"
import { useHasPermissions } from "../../hooks/hasPermissions.hook.ts"
import { useAppSelector } from "../../store/selectors/app.selector"
import { runtimeSelector } from "../../store/selectors/runtime.selector"
import { DashboardEmbedComponent } from "./dashboardEmbed.component.tsx"

export const InsightsComponent: React.FunctionComponent = () => {
    useScrollFix()

    useHasPermissions(OneVerifyPermission.viewPracticeInsights)

    const runtimeState = useAppSelector(runtimeSelector)

    return runtimeState.enabledFeatureFlags ? (
        <div className="relative">
            <PageHelmetElement
                title="Dashboard"
                defaultPageTitle={GENERAL_CONFIG.defaultPageTitle}
            />

            <DashboardEmbedComponent
                className="mt-[24px]"
                style={{
                    height: `calc(100vh - ${GENERAL_CONFIG.headerHeight}px - 24px)`, // header + margin top
                }}
                embedType={DashboardEmbedType.DASHBOARD}
                embedId={COMMON_METABASE_CONFIG.embeds.dashboards.oneVerifyMain}
            />
        </div>
    ) : (
        <SpinnerElement containerClassName="text-center mt-[48px]" />
    )
}
